import { CalendarClock, X } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

/**
 * Pending scheduled broadcasts — each row can be cancelled up until it
 * fires. Realtime WS `broadcast.fired` events remove rows via parent
 * (see main SmsBroadcastCard).
 */
export function ScheduledStrip({ scheduled, setScheduled }) {
  const cancel = async (sid) => {
    try {
      await api.delete(`/ghl/sms-broadcast/schedule/${sid}`);
      setScheduled((prev) => prev.filter((s) => s.id !== sid));
      toast.success("Schedule cancelled");
    } catch { toast.error("Cancel failed"); }
  };

  if (scheduled.length === 0) return null;
  return (
    <div className="mb-4" data-testid="sms-broadcast-scheduled">
      <div className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-zinc-500 mb-2">
        <CalendarClock className="h-3 w-3" /> Scheduled ({scheduled.length})
      </div>
      <div className="space-y-1.5">
        {scheduled.map((s) => (
          <div key={s.id}
               className="flex items-center gap-2 rounded-md border border-white/10 bg-white/[0.03] px-3 py-2 text-xs"
               data-testid={`sms-broadcast-scheduled-${s.id}`}>
            <span className="text-orange-300 font-medium shrink-0">
              {new Date(s.scheduled_for).toLocaleString(undefined, {
                month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
              })}
            </span>
            <span className="text-zinc-400 truncate flex-1">{s.body}</span>
            <button onClick={() => cancel(s.id)}
                    className="text-zinc-400 hover:text-red-400 p-1 shrink-0"
                    data-testid={`sms-broadcast-scheduled-cancel-${s.id}`} title="Cancel">
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
